import { Tab } from "@headlessui/react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import logo from "assets/images/sportswear-erp.png";

import { FastSpringProvider } from "features/Contexts/fastSpringContext";
import CompanyForm from "./CompanyForm";
import FastSpring from "./FastSpring";
import UserForm from "./userForm";
import Toast from "components/Toast/ToastComponent";

// const stripePromise = loadStripe(
//   `${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}`
// );

function Register() {
  const navigate = useNavigate();

  const { userInfo } = useSelector((state) => state.user);
  const { company } = useSelector((state) => state.company);
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    if (
      userInfo !== null &&
      userInfo?.companyId !== undefined &&
      company?.id === userInfo?.companyId

      // && company?.subscriptionPlan !== null
    ) {
      navigate("/dashboard");
    }

    // const fetchPrices = async () => {
    //   const { prices } = await fetch(
    //     `${process.env.REACT_APP_API_URI}/list-products`,
    //     {
    //       method: "POST",
    //       headers: { "Content-Type": "application/json" },
    //     }
    //   ).then((r) => r.json());
    //   setPrices(prices);
    // };

    // fetchPrices();
  }, [userInfo]);

  // const createSubscription = async (priceId) => {
  //   await API.post("/create-subscription", {
  //     priceId,
  //     customerId: userInfo.customerId,
  //   }).then((r) => {
  //     setClientSecret(r.data.clientSecret);
  //   });

  //   setPlan(priceId);
  // };

  return (
    <div className="App">
      <div className="navbar bg-primary p-3">
        <a className="navbar-brand pull-md-left pull-xs-left" href="/">
          <img src={logo} alt="logo" height="50" />
        </a>
      </div>
      <Toast />

      <div className="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="card">
                <div className="card-body pt-0">
                  <Tab.Group
                    selectedIndex={selectedIndex}
                    onChange={setSelectedIndex}
                  >
                    <Tab.List
                      as="ul"
                      className="nav nav-pills nav-justified form-wizard-header mb-3"
                    >
                      <Tab
                        as="li"
                        className="nav-item"
                        // disabled={userInfo}
                      >
                        {({ selected }) => (
                          <span
                            className={
                              selected
                                ? "nav-link rounded-0 py-2 active"
                                : "nav-link rounded-0 py-2"
                            }
                          >
                            <i className="mdi mdi-account-circle font-18 align-middle me-1"></i>
                            <span className="d-none d-sm-inline">
                              Create Account
                            </span>
                          </span>
                        )}
                      </Tab>
                      <Tab
                        as="li"
                        className="nav-item"
                        // disabled={!company}
                      >
                        {({ selected }) => (
                          <span
                            className={
                              selected
                                ? "nav-link rounded-0 py-2 active"
                                : "nav-link rounded-0 py-2"
                            }
                          >
                            <i className="mdi mdi-face-man-profile font-18 align-middle me-1"></i>
                            <span className="d-none d-sm-inline">
                              Set Up Company
                            </span>
                          </span>
                        )}
                      </Tab>
                      <Tab
                        as="li"
                        disabled={!userInfo || !company}
                        className="nav-item"
                      >
                        {({ selected }) => (
                          <span
                            className={
                              selected
                                ? "nav-link rounded-0 py-2 active"
                                : "nav-link rounded-0 py-2"
                            }
                          >
                            <i className="mdi mdi-checkbox-marked-circle-outline font-18 align-middle me-1"></i>
                            <span className="d-none d-sm-inline">Finish</span>
                          </span>
                        )}
                      </Tab>
                    </Tab.List>

                    <Tab.Panels className="mb-0 b-0">
                      <Tab.Panel>
                        <UserForm
                          selectedIndex={selectedIndex}
                          setSelectedIndex={setSelectedIndex}
                        />
                      </Tab.Panel>

                      <Tab.Panel>
                        <CompanyForm
                          userInfo={userInfo}
                          selectedIndex={selectedIndex}
                          setSelectedIndex={setSelectedIndex}
                        />
                      </Tab.Panel>
                      <Tab.Panel>
                        <FastSpringProvider>
                          <FastSpring />
                        </FastSpringProvider>
                      </Tab.Panel>
                    </Tab.Panels>
                  </Tab.Group>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-12 text-center">
                  <p className="text-muted ">
                    Have an account?
                    <Link to={"/app/client-login/"} className="p-1">
                      <span className="font-weight-bold">
                        Click here to log in
                      </span>
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
